// extracted by mini-css-extract-plugin
export default {"button":"PrevButton_button__y32r9"};